// Generated on 2026-07-13T21:59:02.935Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "273781"
  },
  {
    "marca": "HONDA",
    "busquedas": "267007"
  },
  {
    "marca": "FORD",
    "busquedas": "217926"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "132718"
  },
  {
    "marca": "NISSAN",
    "busquedas": "120351"
  },
  {
    "marca": "KIA",
    "busquedas": "66194"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "60791"
  },
  {
    "marca": "MAZDA",
    "busquedas": "38428"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "37261"
  },
  {
    "marca": "JEEP",
    "busquedas": "35404"
  },
  {
    "marca": "ISUZU",
    "busquedas": "21639"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "12690"
  },
  {
    "marca": "BMW",
    "busquedas": "9060"
  },
  {
    "marca": "DODGE",
    "busquedas": "7140"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "6529"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "5874"
  },
  {
    "marca": "ACURA",
    "busquedas": "2178"
  },
  {
    "marca": "SCION",
    "busquedas": "2108"
  },
  {
    "marca": "SUBARU",
    "busquedas": "1778"
  },
  {
    "marca": "GMC",
    "busquedas": "1737"
  },
  {
    "marca": "MINI",
    "busquedas": "1710"
  },
  {
    "marca": "RAM",
    "busquedas": "1680"
  },
  {
    "marca": "MERCURY",
    "busquedas": "1030"
  },
  {
    "marca": "LEXUS",
    "busquedas": "955"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "821"
  },
  {
    "marca": "VOLVO",
    "busquedas": "724"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "610"
  },
  {
    "marca": "AUDI",
    "busquedas": "570"
  },
  {
    "marca": "HUMMER",
    "busquedas": "474"
  },
  {
    "marca": "SATURN",
    "busquedas": "442"
  },
  {
    "marca": "INFINITI",
    "busquedas": "399"
  },
  {
    "marca": "GEO",
    "busquedas": "339"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "233"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "233"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "230"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "214"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "102"
  },
  {
    "marca": "FIAT",
    "busquedas": "101"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "78"
  },
  {
    "marca": "BUICK",
    "busquedas": "71"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "68"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "46"
  },
  {
    "marca": "RENAULT",
    "busquedas": "38"
  },
  {
    "marca": "JMC",
    "busquedas": "37"
  },
  {
    "marca": "JAC",
    "busquedas": "15"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "13"
  },
  {
    "marca": "FOTON",
    "busquedas": "9"
  },
  {
    "marca": "ZNA",
    "busquedas": "9"
  },
  {
    "marca": "JIM",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "CHERY",
    "busquedas": "5"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "TESLA",
    "busquedas": "4"
  },
  {
    "marca": "CHANGAN",
    "busquedas": "4"
  },
  {
    "marca": "SAAB",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "SMART",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
